import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/esm/Button';
import { useParams } from 'react-router-dom';
import { copyCompetition, getCompetition } from '../../api/Competitions';
import { useEffect } from 'react';

function CompetitionDetailsHeader({
  updatedTime,
  published,
  isLoaded,
  setConfirmPublishModalShow,
  competitionStatus,
  setShowCancelModal,
  setCompetition,
  setToastProps,
}) {
  const { id: competitionId } = useParams();
  const navigate = useNavigate();

  return (
    <div className='w-100'>
      <div
        className='d-flex flex-column flex-md-row justify-content-between p-2 rounded'
        style={{ backgroundColor: 'rgba(251, 251, 251, 0.9)' }}
      >
        <h4>Inbjudan</h4>

        <div className='d-flex flex-column flex-md-row gap-2'>
          {!published && isLoaded && (
            <>
              <span className='text-secondary-black text-sm me-md-3 mt-2 mt-md-0 small align-self-center'>
                {updatedTime ? 'Utkast sparat ' + updatedTime : ''}
              </span>
              <Button
                onClick={() => setConfirmPublishModalShow(true)}
                className='mt-2 mt-md-0'
              >
                Publicera inbjudan
              </Button>
            </>
          )}

          {isLoaded && competitionStatus === 'Kommande' && (
            <Button onClick={() => setShowCancelModal(true)}>
              Ställ in tävling
            </Button>
          )}

          {isLoaded && (
            <Button
              variant='outline-primary'
              onClick={async () => {
                const result = await copyCompetition(competitionId);

                if (result.statusCode === 200) {
                  navigate(
                    `/organizer/competitions/${result.competitionId}/details`
                  );
                  const competitionResult = await getCompetition(
                    result.competitionId
                  );

                  setCompetition(competitionResult.competition);
                  setToastProps({
                    show: true,
                    body: 'Glöm ej att ändra namn på tävlingen.',
                    title: 'Tävlingen har duplicerats',
                    type: 'success',
                  });
                } else {
                  setToastProps({
                    show: true,
                    body: 'Tävlingen kunde inte dupliceras på grund av ett fel.',
                    title: 'Tävlingen kunde inte dupliceras',
                    type: 'danger',
                  });
                }
              }}
            >
              Duplicera tävling
            </Button>
          )}
        </div>
      </div>
      <p className='text-secondary mt-3'>
        {competitionStatus === 'Inställd'
          ? 'Tävlingen är inställd.'
          : !published
          ? 'Detta är ett utkast. Ändringar sparas automatiskt. Välj publicera för att skicka ut inbjudan.'
          : 'Inbjudan är publicerad. Du kan inte göra ändringar.'}
      </p>
    </div>
  );
}

export default CompetitionDetailsHeader;
